import { render, staticRenderFns } from "./cloudPrintList.vue?vue&type=template&id=036d13d8&scoped=true&"
import script from "./cloudPrintList.vue?vue&type=script&lang=js&"
export * from "./cloudPrintList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036d13d8",
  null
  
)

component.options.__file = "cloudPrintList.vue"
export default component.exports